module.exports = __webpack_public_path__ + "media/images/homes/ASingleMenu-8ae10200f475aaab45c539d991979bc8.png";